module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_8023.d4b2e0ad.png";